import React, { useState } from "react";
import { Form, Row, Col, Button, InputGroup } from "react-bootstrap";
import { inputChange, saveDataScrum } from "../../helpers";
import Loader from "../../components/Loader/Loader";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
 
// Formateador COP (sin decimales)
const formatter = new Intl.NumberFormat('es-CO', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
});
 
function CurrencyInput({ value, onChange, ...rest }) {
  const formatted = value ? formatter.format(Number(value)) : '';
 
  const handleChange = e => {
    const onlyNums = e.target.value.replace(/\D/g, '');
    onChange(onlyNums);
  };
 
  return (
    <Form.Control
      {...rest}
      type="text"
      value={formatted}
      onChange={handleChange}
    />
  );
}
 
const FormRiskRequest = () => {
  const history = useHistory();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [mainData, setMainData] = useState({
    Cliente: "",
    nit: "",
    NombreOportunidad: "",
    Descripcion: "",
    PresupuestoEstimado: "",
    FechaEnvioPropuesta: "",
    EsPublica: "",
    CorreoCliente: "",
    LinkDocumento: "",
    Prioridad:"",
    Observaciones:"",
  });

  const projectId =  process.env.REACT_APP_FORM_RISK_REQUEST_PROJECTID; 
  const backlogUID = process.env.REACT_APP_FORM_RISK_REQUEST_BACKLOGUID;

  const laneId = null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);

    const cardData = {
      title: mainData.NombreOportunidad,
      uid: projectId,
      backlogUID,
      laneId,
    };
 
    saveDataScrum("agile-cards", cardData)
      .then((res) => {
        const noteText =
          `Cliente: ${mainData.Cliente}\n` +
          `Nit: ${mainData.nit}\n` +
          `Nombre de la oportunidad: ${mainData.NombreOportunidad}\n` +
          `Prioridad: ${mainData.Prioridad}\n` +
          `Descripción breve del servicio: ${mainData.Descripcion}\n` +
          `Presupuesto estimado: $${mainData.PresupuestoEstimado}\n` +
          `Fecha de envío de la propuesta: ${mainData.FechaEnvioPropuesta}\n` +
          `Tipo: ${mainData.EsPublica === "publica" ? "Pública" : "Privada"}\n` +
          `Correo de contacto: ${mainData.CorreoCliente}\n` +
          `Link gestión documental: ${mainData.LinkDocumento}\n` +
          `Observaciones: ${mainData.Observaciones}`;
        return saveDataScrum("risk-notes", { taskId: res.id, noteText , prioridad: mainData.Prioridad });
      })
      .then(() => {
        swal(
          "Guardado!",
          "La oportunidad de riesgo se guardó exitosamente.",
          "success"
        ).then(() => {
             setIsSubmitting(false);
             history.push("/landing")
            }
        );
      })
      .catch(() => {
        setIsSubmitting(false);
        swal("Error", "Hubo un error al procesar la solicitud", "error");
      });
  };

  return (
    <>
        {isSubmitting && <Loader />}
        <Form onSubmit={handleSubmit} className="p-4 shadow rounded bg-light">
            <h5 className="mb-4 text-primary fw-bold">
                <i className="fas fa-clipboard-list mr-2"></i>
                Registrar Oportunidad
            </h5>

            <Row>
              <Col md={6} className="mb-3">
                <Form.Group controlId="formCliente">
                    <Form.Label><i className="fas fa-user mr-2 text-secondary"></i>Cliente <small className="text-danger">*</small></Form.Label>
                    <Form.Control
                    name="Cliente"
                    placeholder="Nombre del cliente"
                    onChange={(e) => inputChange(e, setMainData)}
                    value={mainData.Cliente}
                    required
                    disabled={isSubmitting}
                    />
                  </Form.Group>
                </Col>
                <Col md={6} className="mb-3">
                  <Form.Group controlId="formNIT">
                    <Form.Label><i className="fas fa-id-card mr-2 text-secondary"></i>NIT <small className="text-danger">*</small></Form.Label>
                    <Form.Control
                    name="nit"
                    placeholder="Número de identificación tributaria"
                    onChange={(e) => inputChange(e, setMainData)}
                    value={mainData.nit}
                    required
                    disabled={isSubmitting}
                    />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6} className="mb-3">
                <Form.Group controlId="formNombreOportunidad">
                    <Form.Label><i className="fas fa-lightbulb mr-2 text-secondary"></i>Nombre de la oportunidad <small className="text-danger">*</small></Form.Label>
                    <Form.Control
                    name="NombreOportunidad"
                    placeholder="Ej. Consultoría financiera"
                    onChange={(e) => inputChange(e, setMainData)}
                    value={mainData.NombreOportunidad}
                    required
                    disabled={isSubmitting}
                    />
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group controlId="formDescripcion">
                    <Form.Label><i className="fas fa-align-left mr-2 text-secondary"></i>Descripción breve del servicio <small className="text-danger">*</small></Form.Label>
                    <Form.Control
                    as="textarea"
                    rows={3}
                    name="Descripcion"
                    placeholder="Describa brevemente el servicio ofrecido..."
                    onChange={(e) => inputChange(e, setMainData)}
                    value={mainData.Descripcion}
                    required
                    disabled={isSubmitting}
                    />
                </Form.Group>
              </Col>
            </Row>

            <Row>
            <Col md={3} className="mb-3">
              <Form.Group controlId="formPresupuesto">
                <Form.Label><i className="fas fa-dollar-sign mr-2 text-secondary"></i>Presupuesto estimado <small className="text-danger">*</small></Form.Label>
                  <InputGroup>
                    <InputGroup.Text>$</InputGroup.Text>
                      <CurrencyInput
                          name="PresupuestoEstimado"
                          value={mainData.PresupuestoEstimado}
                          onChange={val =>
                          setMainData(prev => ({ ...prev, PresupuestoEstimado: val }))
                          }
                          placeholder="0"
                          required
                          disabled={isSubmitting}
                      />
                    <InputGroup.Text>COP</InputGroup.Text>
                  </InputGroup>
                </Form.Group>
                </Col>
                <Col md={3} className="mb-3">
                  <Form.Group controlId="formFechaEnvio">
                    <Form.Label><i className="fas fa-calendar-alt mr-2 text-secondary"></i>Fecha de envío de la propuesta <small className="text-danger">*</small></Form.Label>
                    <Form.Control
                    type="date"
                    name="FechaEnvioPropuesta"
                    onChange={(e) => inputChange(e, setMainData)}
                    value={mainData.FechaEnvioPropuesta}
                    required
                    disabled={isSubmitting}
                    />
                  </Form.Group>
                </Col>
                <Col md={3} className="mb-3">
                  <Form.Group controlId="formTipo">
                    <Form.Label><i className="fas fa-globe mr-2 text-secondary"></i>¿Es pública o privada? <small className="text-danger">*</small></Form.Label>
                    <div className="d-flex gap-3 mt-2">
                    <Form.Check
                        inline
                        type="radio"
                        label="Pública"
                        name="EsPublica"
                        value="publica"
                        onChange={(e) => inputChange(e, setMainData)}
                        checked={mainData.EsPublica === "publica"}
                        required
                        disabled={isSubmitting}
                    />
                    <Form.Check
                        inline
                        type="radio"
                        label="Privada"
                        name="EsPublica"
                        value="privada"
                        onChange={(e) => inputChange(e, setMainData)}
                        checked={mainData.EsPublica === "privada"}
                        required
                        disabled={isSubmitting}
                    />
                    </div>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Label><i className="fas fa-sort-amount-up-alt mr-2 text-secondary"></i>Prioridad <small className="text-danger">*</small></Form.Label>
                  <Form.Control
                    as="select"
                    name="Prioridad"
                    value={mainData.Prioridad}
                    onChange={(e) => inputChange(e, setMainData)}
                    required
                    disabled={isSubmitting}
                  >
                    <option value="">Seleccione...</option>
                    <option value="Alta">Alta</option>
                    <option value="Media">Media</option>
                    <option value="Baja">Baja</option>
                  </Form.Control>
              </Col>
            </Row>

            <Row>
                <Col md={6} className="mb-3">
                  <Form.Group controlId="formCorreoContacto">
                      <Form.Label><i className="fas fa-envelope mr-2 text-secondary"></i>Correo de contacto del cliente <small className="text-danger">*</small></Form.Label>
                      <Form.Control
                      type="email"
                      name="CorreoCliente"
                      placeholder="cliente@empresa.com"
                      onChange={(e) => inputChange(e, setMainData)}
                      value={mainData.CorreoCliente}
                      required
                      disabled={isSubmitting}
                      />
                  </Form.Group>
                </Col>
                <Col md={6} className="mb-3">
                  <Form.Group controlId="formLinkGestion">
                      <Form.Label><i className="fas fa-link mr-2 text-secondary"></i>Link a gestión documental</Form.Label>
                      <Form.Control
                      name="LinkDocumento"
                      placeholder="https://drive.google.com/..."
                      onChange={(e) => inputChange(e, setMainData)}
                      value={mainData.LinkDocumento}
                      disabled={isSubmitting}
                      />
                  </Form.Group>
                </Col>
            </Row>

            <Row>
              <Col md={12} className="mb-3">
                <Form.Group controlId="formObservaciones">
                  <Form.Label><i className="fas fa-sticky-note mr-2 text-secondary"></i>Observaciones</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="Observaciones"
                    placeholder="Comentarios adicionales..."
                    onChange={e => inputChange(e, setMainData)}
                    value={mainData.Observaciones}
                    disabled={isSubmitting}
                  />
                </Form.Group>
              </Col>
            </Row>

            <hr className="my-4" />
            <Row className="align-items-start">
              <Col md={4} className="mb-3 d-flex justify-content-start gap-2"> 
                <Button
                    variant="outline-secondary mr-5"
                    onClick={() => history.push("/landing")}
                    disabled={isSubmitting}
                >
                    <i className="fas fa-times mr-2"></i>Cancelar
                </Button>
                <Button variant="primary" type="submit" disabled={isSubmitting}>
                    <i className="fas fa-save mr-2"></i> Guardar
                </Button>
              </Col>
            </Row>
        </Form>
    </>
  );
};

export default FormRiskRequest;
